import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import useTranslation from 'Hooks/useTranslation';
import { AddDocument } from 'Images/index';
import Firebase from 'Api/Firebase';
import { S3_DOCUMENTS } from 'Constants/General';
import { s3 } from 'Services/AWS/s3';
import { CardContainer, IconContaniner, InfoContainer, TitleUpload, Image, containerStyle } from './style';

export default function UploadDocumentCard({
  titleUploadDocument = '',
  courseId,
  createDocument,
  documents,
  setError,
}) {
  const { t2 } = useTranslation('EditCourse');
  const [isUpload, setIsUpload] = useState(false);
  const documentNames = documents.map(doc => doc.name);
  const icon = AddDocument;

  const { acceptedFiles, getRootProps, getInputProps, fileRejections } = useDropzone({
    accept: ['.docx', 'application/pdf', '.doc'],
    maxFiles: 1,
  });

  const file = acceptedFiles[0];

  if (fileRejections.length > 0) {
    if (fileRejections[0].errors[0].code === 'too-many-files') {
      setError(t2('CourseDocumentErrorMultiple'));
    }

    if (fileRejections[0].errors[0].code === 'file-invalid-type') {
      setError(t2('DocumentUploadTypeError'));
    }
  }

  if (acceptedFiles.length > 0 && documentNames.includes(file?.name)) {
    setError(t2('CourseDocumentErrorDuplicate'));
  }

  if (acceptedFiles.length > 0 && !documentNames.includes(file?.name)) {
    setIsUpload(true);
  }

  const key = `${S3_DOCUMENTS}/${courseId}/${file?.name}`;

  const firebaseUpload = async () => {
    try {
      await s3.uploadFileToBucketWithKeyProvided(key, file, file.type);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(`Error ${e}`);
      return false;
    }
    return true;
  };

  if (isUpload && !documentNames.includes(file?.name)) {
    firebaseUpload();
    createDocument(file?.name, file?.size, key);
    setIsUpload(false);
    acceptedFiles.pop();
    setError('');
  }
  if (!isUpload && documentNames.includes(file?.name)) {
    acceptedFiles.pop();
  }

  return (
    <div style={containerStyle}>
      <CardContainer {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <IconContaniner>
          <img style={Image} src={icon} />
        </IconContaniner>
        <InfoContainer>
          <div style={TitleUpload}>{titleUploadDocument}</div>
        </InfoContainer>
      </CardContainer>
    </div>
  );
}
